import { createSlice } from '@reduxjs/toolkit';

// 初期型
// eslint-disable-next-line @typescript-eslint/naming-convention
export interface SeoTextState {
  titleOrText: string | null;
  text: string | null;
  areaText: string | null;
  careerExplainText: string | null;
  defaultFlg: boolean;
}

// 初期状態
export const seoTextInitialState: SeoTextState = {
  titleOrText: null,
  text: null,
  areaText: null,
  careerExplainText: null,
  defaultFlg: false,
};

/**
 * SeoText Slice
 * @remarks Seoテキストの情報を保存
 */
export const seoTextSlice = createSlice({
  name: 'seoText',
  initialState: seoTextInitialState,
  reducers: {
    setSeoText: (state, action) => {
      state.titleOrText = action.payload.titleOrText;
      state.text = action.payload.text;
      state.careerExplainText = action.payload.careerExplainText;
      state.defaultFlg = action.payload.defaultFlg;
      state.areaText = action.payload.areaText;
    },
  },
});

export const { setSeoText } = seoTextSlice.actions;

// reducer
export const seoTextReducer = seoTextSlice.reducer;

// selector
/**
 * seoTextSelector
 * @param state
 */
export const seoTextSelector = (state) => state.seoText;
